import { createSelector } from '@reduxjs/toolkit'
import { getBusinessTravellerSelectedTravellerState } from 'businessTraveller/storage/businessTravellerStorage'
import { EMPTY_EMPLOYEE_IDS } from './emptyEmployeeIds'

export const selectSelectedTravellerEmployeeIds = createSelector(
  (state: App.State) => state.businessTraveller.selectedTravellerEmployeeIds,
  (selectedTravellerEmployeeIds): Array<string> => {
    if (selectedTravellerEmployeeIds.length > 0) {
      return selectedTravellerEmployeeIds
    }
    return getBusinessTravellerSelectedTravellerState()?.employeeIds ?? EMPTY_EMPLOYEE_IDS
  },
)
